import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { companyForLink, recordWebsiteEvent } from '@/lib/website-analytics';

let lastLocation = '';
export default function PublicWebsiteEvents() {
  const { pathname, key } = useLocation();
  useEffect(() => {
    const location = `${key}:${pathname}`;
    if (lastLocation !== location) { lastLocation = location; recordWebsiteEvent('pageview'); }
  }, [pathname,key]);
  useEffect(() => {
    const click = (event) => {
      const link = event.target.closest?.('a[href]');
      if (!link) return;
      const company = companyForLink(link.href);
      if (company) recordWebsiteEvent('portfolio_click',company);
      else if (/^(mailto:|tel:)/.test(link.getAttribute('href'))) recordWebsiteEvent('contact_click');
    };
    document.addEventListener('click',click,true);
    return () => document.removeEventListener('click',click,true);
  }, []);
  return null;
}
